import { FC } from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
};

const SpeedUp: FC<Props> = ({ className }) => (
  <svg
    className={classNames('w-[24px] h-[24px] stroke-[1.5px]', className)}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8.5 4.00024H1.5M7.5 20.0002H1.5M4.5 12.0002H1.5M9.32 13.2802H12.41V20.4802C12.41 21.5402 13.73 22.0402 14.43 21.2402L22 12.6402C22.66 11.8902 22.13 10.7202 21.13 10.7202H18.04V3.52024C18.04 2.46024 16.72 1.96024 16.02 2.76024L8.45 11.3602C7.8 12.1102 8.33 13.2802 9.32 13.2802Z"
      stroke="currentColor"
      strokeWidth="currentStrokWidth"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SpeedUp;
